export default {
  title: {
    en: 'OHOH!',
    ar: 'يا للأسف!'
  },
  text: {
    en: "If you only have 1 Avatar, you can't delete it.",
    ar: 'إذا كان لديك أڤاتار واحد، فلا يمكنك حذفه.'
  },
  button: {
    en: 'Ok',
    ar: 'حسناً'
  }
};
